import { render, staticRenderFns } from "./SwitchTab.vue?vue&type=template&id=c70c6c5a&"
import script from "./SwitchTab.vue?vue&type=script&lang=js&"
export * from "./SwitchTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports